import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { Flower, GraduationCap, Plus, Users } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { VerificationBadge } from "@/components/MemorialBadges";

export default function InstitutionMemorials({ instName }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!instName) return;
    api.get(`/public/memorials?institution=${encodeURIComponent(instName)}`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [instName]);

  if (rows === null) return null;

  return (
    <section className="mt-12" data-testid="institution-memorials">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl font-light tracking-tight"><Flower size={22} weight="duotone" className="text-secondary" /> In Memory</h2>
          <p className="mt-1 text-sm text-muted-foreground">Remembering members of {instName} who are part of our story.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/memorials/suggest"><Button variant="outline" size="sm" className="rounded-full gap-1.5" data-testid="inst-suggest-memorial"><Users size={14} /> Suggest a Classmate</Button></Link>
          <Link to="/memorials/create"><Button size="sm" className="rounded-full gap-1.5" data-testid="inst-create-memorial"><Plus size={14} /> Create a Memorial</Button></Link>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border/60 p-8 text-center text-sm text-muted-foreground">
          No memorials yet for {instName}. Help preserve the memory of a classmate or teacher.
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {rows.slice(0, 8).map((m) => {
            const years = [m.dob, m.dop].filter(Boolean).join(" – ");
            return (
              <Link key={m.id} to={`/memorials/${m.id}`} data-testid={`inst-memorial-${m.id}`}
                className="flex flex-col items-center rounded-2xl border border-border/60 bg-card p-4 text-center transition-colors hover:border-secondary/50">
                <div className="mb-3 h-16 w-16 overflow-hidden rounded-full ring-2 ring-secondary/20">
                  {m.photo_file_id ? <img src={fileUrl(m.photo_file_id)} alt={m.name} className="h-full w-full object-cover" /> : <span className="grid h-full w-full place-items-center bg-accent text-lg font-heading text-primary">{(m.name || "?")[0]}</span>}
                </div>
                <p className="font-heading text-sm font-medium">{m.name}</p>
                {years && <p className="text-xs text-muted-foreground">{years}</p>}
                {m.class_batch && <p className="mt-1 flex items-center gap-1 text-[11px] text-muted-foreground"><GraduationCap size={11} /> {m.class_batch}</p>}
                <div className="mt-2"><VerificationBadge status={m.verification_status} /></div>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}
